var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScratch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 509,
    height: 737,
    viewBox: "0 0 509 737",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.5 1C343.449 1 508 165.551 508 368.5C508 571.449 343.449 736 140.5 736C-62.4486 736 -227 571.449 -227 368.5C-227 165.551 -62.4486 1 140.5 1Z",
    stroke: "#FFEF00",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.283 558.814C359.534 558.814 478.932 440.049 478.932 294.549C478.932 149.049 359.534 30.0677 213.283 30.0677C67.0318 30.0677 -52.5938 148.832 -52.5938 294.56C-52.5938 440.287 66.7926 558.825 213.283 558.825V558.814Z",
    stroke: "#00A8E1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5119 706.932C215.21 706.932 334.972 588.168 334.972 442.667C334.972 297.167 215.221 178.175 68.5119 178.175C-78.1972 178.175 -197.938 296.951 -197.938 442.667C-197.938 588.384 -78.4154 706.932 68.5228 706.932H68.5119Z",
    stroke: "#FF5C00",
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScratch);
export default __webpack_public_path__ + "static/media/scratch.72834f6287eb766b23a18e1f675de373.svg";
export { ForwardRef as ReactComponent };